//@flow
import React from 'react';
import { withRouter } from 'react-router';
import HeapActions from '../../Actions/heap';
import UrlData from '../../Utils/url-data';

import type { ContextRouter } from 'react-router';
import type QuoteItemsCollection from '../../Stores/Quote/quoteItemsCollection';
import type CustomerModel from '../../Stores/Customer/customerModel';

type Props = ContextRouter&{
  quoteItems:?QuoteItemsCollection,
  newMember:boolean,
  children?:any,
  id?:string,
  customer:CustomerModel,
  shouldIncludeQueryParams?:boolean,
};

class CheckoutButton extends React.Component<Props> {
  _hasItems() {
    return this.props.quoteItems &&
      this.props.quoteItems.getTotalItemsQty() !== 0;
  }

  handleClick = () => {
    if (!this._hasItems()) return this.props.router.push('/products');

    HeapActions.trackCartGoToCheckout();

    if (this.props.customer.hasMembershipOrders()) return this.props.router.push(UrlData.makeUrlWithQuery('/checkout/confirm'));
    if (this.props.newMember) return this.props.router.push(UrlData.makeUrlWithQuery('/checkout/shipping'));

    this.props.router.push(UrlData.makeUrlWithQuery('/checkout'));
  }

  _getText() {
    return 'Proceed to checkout';
  }

  render() {
    return (
      <button
        className="checkout-btn cta"
        id={this.props.id || "CheckoutButton-proceed-button"}
        onClick={this.handleClick}
      >
        {this.props.children || this._getText()}
      </button>
    );
  }
}

export default withRouter(CheckoutButton);
